import React from 'react';
import { Box, Container, Skeleton } from '@mui/material';

const OdpovedSkeleton: React.FC = () => {
    return (
        <Container maxWidth="sm" sx={{ mt: 2, textAlign: "center" }}>
            {/* Nadpis */}
            <Skeleton variant="text" width={150} height={50} sx={{ mx: 'auto', mb: 1 }} />

            {/* Událost */}
            <Skeleton variant="text" width="80%" height={35} sx={{ mx: 'auto', mb: 2 }} />

            {/* Popis */}
            <Skeleton variant="text" width="60%" height={25} sx={{ mx: 'auto', mb: 2 }} />

            {/* Čas od vyhlášení */}
            <Skeleton variant="text" width={100} height={40} sx={{ mx: 'auto', mb: 1 }} />

            {/* Status odpovědi */}
            <Skeleton variant="text" width={180} height={30} sx={{ mx: 'auto', mb: 3 }} />

            {/* Tlačítka JEDU/NEJEDU */}
            <Box mt={2} display="flex" flexDirection="column" alignItems="center" gap={2}>
                <Skeleton
                    variant="rectangular"
                    width={300}
                    height={80}
                    sx={{ borderRadius: 1 }}
                />
                <Skeleton
                    variant="rectangular"
                    width={300}
                    height={80}
                    sx={{ borderRadius: 1 }}
                />
            </Box>

            {/* Detail poplachu button */}
            <Box mt={5}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={40}
                    sx={{ borderRadius: 1 }}
                />
            </Box>

            {/* Odpovědi jednotky */}
            <Box mt={4}>
                <Skeleton variant="text" width={150} height={30} sx={{ mx: 'auto', mb: 2 }} />
                <Box display="flex" justifyContent="center" gap={4}>
                    <Skeleton variant="text" width={80} height={25} />
                    <Skeleton variant="text" width={80} height={25} />
                </Box>
            </Box>
        </Container>
    );
};

export default OdpovedSkeleton;
